<!-- eslint-disable vue/no-v-html -->
<template>
  <ContainerBasic
    container-type="PAGE"
    :class="isHeader ? '!mt-0 md:!mt-0' : ''"
    class="print:max-w-[720px] print:mx-auto"
  >
    <div
      ref="mobileHeadlineRef"
      :style="blockData.bgColor?.style ?? ''"
      class="print:hidden"
    >
      <HeadlineDynamic
        v-if="blockData.headline && isMobile"
        :class="blockData.text ? 'p-lg !pb-sm' : 'p-lg'"
        :has-decoration="true"
        :headline="blockData.headline"
        level="h1"
        :logo-color="
          blockData.bgColor?.themeType !== 'BASE' ? '#346e73' : 'white'
        "
        :text-color="
          blockData.bgColor?.themeType !== 'BASE' ? '' : 'text-white'
        "
        :deco-container-classes="
          blockData.bgColor?.themeType !== 'BASE' ? '' : 'stroke-white'
        "
      />
      <div
        v-if="blockData.text && isMobile"
        class="text-center px-md pb-md [&_p]:mb-2xs"
        v-html="blockData.text"
      ></div>
    </div>

    <ClientOnly>
      <ImageCarousel
        :show="state.showCarousel"
        :images="blockData.images"
        :active-index="state.carouselIndex"
        @close="state.showCarousel = false"
      />
      <section
        v-if="blockData"
        class="pb-lg"
        :class="'section' + (cutOffImageGrid() ? ' print:p-0' : '')"
      >
        <div
          ref="gridRef"
          :key="gridKey"
          :class="[
            'grid gap-md grid-cols-',
            'grid-cols-' +
              (isMobile
                ? blockData.images.length > 1
                  ? 2
                  : 1
                : colCountForAmountImages[blockData.images.length] || 4) +
              (blockData.images.length > 1 ? ' p-md' : ' md:p-md'),
          ]"
          class="print:!grid-cols-2 print:!p-0 print:!gap-sm print:!pt-xs"
          :style="imageContainerStyle"
        >
          <div
            v-if="blockData.headline && !isMobile"
            class="relative justify-center"
            :class="'print:hidden flex flex-col ' + getColAndRowStyle(-1)"
            :style="(headingContainerStyle, blockData.bgColor?.style)"
          >
            <div
              v-if="
                blockData.badgeLeft !== EBadge.NONE ||
                blockData.badgeRight !== EBadge.NONE
              "
              class="grid grid-cols-2 mt-md mb-md"
            >
              <img
                v-if="blockData.badgeLeft === EBadge.VOLLTREFFER"
                src="~/assets/images/volltreffer-badge.svg"
                alt="Volltreffer-Badge"
              />
              <img
                v-if="blockData.badgeRight === EBadge.DIGITAL_EXCELLENCE_LOGO"
                class="col-start-2 ml-auto mr-sm"
                alt="Digital Excellence Logo"
                src="~/assets/images/digital-excellence-logo.svg"
              />
            </div>
            <HeadlineDynamic
              container-classes="flex flex-col items-center justify-center p-md"
              :has-decoration="true"
              :headline="blockData.headline"
              :deco-container-classes="
                blockData.bgColor?.themeType !== 'BASE' ? '' : 'stroke-white'
              "
              :logo-color="
                blockData.bgColor?.themeType !== 'BASE' ? '#346e73' : 'white'
              "
              level="h1"
              :text-color="
                blockData.bgColor?.themeType !== 'BASE' ? '' : 'text-white'
              "
              width="w-full"
            />
            <div
              v-if="blockData.text"
              class="text-center px-md pb-md [&_p]:mb-2xs"
              v-html="blockData.text"
            ></div>
          </div>

          <!-- ### Print Version START -->
          <div class="hidden print:block">
            <div class="relative">
              <img
                v-if="blockData.badgeLeft === EBadge.VOLLTREFFER"
                src="data:image/svg+xml;base64,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"
                alt="Volltreffer-Badge"
                class="absolute top-0 left-0 -translate-y-1/2 w-[130px] z-10"
              />

              <img
                v-if="blockData.badgeRight === EBadge.DIGITAL_EXCELLENCE_LOGO"
                src="data:image/svg+xml;base64,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"
                alt="Digital Excellence Logo"
                class="absolute top-[5px] right-[2px] w-[115px] z-10"
              />
            </div>

            <div class="hidden h-full grid-cols-1 gap-6 print:grid">
              <div
                v-if="blockData.headline"
                class="relative justify-center"
                :class="'flex flex-col'"
                :style="(headingContainerStyle, blockData.bgColor?.style)"
              >
                <HeadlineDynamic
                  container-classes="flex flex-col items-center justify-center px-md print:!pb-0"
                  :has-decoration="true"
                  :headline="blockData.headline"
                  :deco-container-classes="
                    blockData.bgColor?.themeType !== 'BASE'
                      ? ''
                      : 'stroke-white'
                  "
                  :logo-color="
                    blockData.bgColor?.themeType !== 'BASE'
                      ? '#346e73'
                      : 'white'
                  "
                  level="h1"
                  :text-color="
                    blockData.bgColor?.themeType !== 'BASE' ? '' : 'text-white'
                  "
                  width="w-full"
                />
                <div
                  v-if="blockData.text"
                  class="text-center px-md"
                  v-html="blockData.text"
                ></div>
              </div>
            </div>
          </div>

          <!-- ### Print Version END ### -->
          <div
            v-for="(image, index) in blockData.images"
            :key="image.id"
            :class="'print:mr-8 flex flex-auto ' + getColAndRowStyle(index)"
          >
            <img
              v-if="getFirstOneRowImageIndex() !== index"
              :src="image.url"
              :alt="image.altText"
              :title="image.title"
              :loading="renderIndex < 4 ? 'eager' : 'lazy'"
              class="flex flex-auto object-cover cursor-pointer aspect-video"
              @click="openImageCarousel(index)"
            />
            <img
              v-if="getFirstOneRowImageIndex() === index"
              ref="lastImgRef"
              :src="image.url"
              :alt="image.altText"
              :title="image.title"
              :loading="renderIndex < 4 ? 'eager' : 'lazy'"
              class="flex flex-auto object-cover cursor-pointer aspect-video"
              @click="openImageCarousel(index)"
              @load="onLastImageLoaded()"
            />
          </div>
        </div>
        <div class="text-center mx-lg"></div>
        <div
          v-if="cutOffImageGrid()"
          class="absolute pointer-events-none bg-gradient-to-t from-white"
          :style="gradientOverlayPosition"
        />
        <div
          v-if="blockData.images.length > 8"
          :class="[
            'flex flex-row items-center justify-center',
            state.showAllImages ? '' : isMobile ? 'mt-sm' : 'mt-md',
          ]"
        >
          <div
            class="w-full border-dotted border-t-1 border-vdv-border-dark mx-md"
          />
          <div
            v-if="state.showAllImages === false"
            class="flex flex-row items-center justify-center cursor-pointer text-vdv-base whitespace-nowrap"
            @click="toggleImages(true)"
          >
            <p v-text="t('extendedGallery.showMore')" />
            <div class="pl-xs">
              <FaIcon icon-class="fas fa-chevron-down" />
            </div>
          </div>
          <div
            v-if="state.showAllImages === true"
            class="flex flex-row items-center justify-center cursor-pointer text-vdv-base whitespace-nowrap"
            @click="toggleImages(false)"
          >
            <p v-text="t('extendedGallery.showLess')" />
            <div class="pl-xs">
              <FaIcon icon-class="fas fa-chevron-up" />
            </div>
          </div>
          <div
            class="w-full border-dotted border-t-1 border-vdv-border-dark mx-md"
          />
        </div>
      </section>
    </ClientOnly>
    <div
      v-if="isHeader"
      class="bg-activesection-base w-full h-[36px] print:hidden"
    />
  </ContainerBasic>
</template>

<script setup lang="ts">
import { useResizeObserver } from '@vueuse/core';
import { EBadge } from '@/@types/badge';
import ContainerBasic from '@/components/components/container-basic.vue';
import ImageCarousel from '@/components/components/core/image-carousel/image-carousel.vue';
import HeadlineDynamic from '@/components/components/core/headline-dynamic/vdv/headline-dynamic.vue';
import { mq_breakpointIsMobile } from '@/injectionSymbols';
import type { ImageGalleryExtendedData } from '../blockType';
import FaIcon from '@/components/fa-icon.vue';

const props = defineProps({
  blockData: {
    type: Object as PropType<ImageGalleryExtendedData>,
    required: true,
    default: {} as ImageGalleryExtendedData,
  },
  isHeader: {
    type: Boolean,
    required: true,
    default: () => {
      return false;
    },
  },
  renderIndex: {
    type: Number,
    required: false,
    default: 999,
  },
});
const { t } = useTrans();

const isMobile = inject(mq_breakpointIsMobile);
const gridRef = ref(null);
const lastImgRef = ref(null);
const gradientOverlayPosition = ref('');
const rowHeight = ref(0);
const imageContainerStyle = ref('');
const mobileHeadlineRef = ref<HTMLDivElement>();
const gridKey = ref(0);

onMounted(() => {
  calculateStyles();
});

useResizeObserver(gridRef, (entries) => {
  const entry = entries[0];
  state.gridRect = entry.contentRect;
  calculateStyles();
});

function calculateStyles(): void {
  if (lastImgRef.value?.[0]?.clientHeight) {
    rowHeight.value = lastImgRef.value[0].clientHeight;
  }

  if (cutOffImageGrid()) {
    let cutOffHeight;
    const halfRowHeight = 0.5 * rowHeight.value;

    if (state.gridRect && gridRef.value) {
      gradientOverlayPosition.value = `width: ${
        state.gridRect.width + 50
      }px; height: ${halfRowHeight}px; top: ${
        gridRef.value.offsetTop + gridRef.value.offsetHeight - halfRowHeight
      }px;`;
    }

    if (isMobile.value === true) {
      // 140 px = 4 * 35 px grid gap
      cutOffHeight = 140 + 4.5 * rowHeight.value;
    } else {
      // 105 px = 3 * 35 px grid gap
      cutOffHeight = 105 + 3.5 * rowHeight.value;
    }
    imageContainerStyle.value = ` overflow: hidden; height: ${cutOffHeight}px`;
  } else {
    imageContainerStyle.value = '';
  }
}

function toggleImages(show: boolean): void {
  state.showAllImages = show;
  if (!show && isMobile.value) {
    mobileHeadlineRef.value.scrollIntoView({ behavior: 'smooth' });
  }
  calculateStyles();
}

function getColAndRowStyle(imageIndex: number): string {
  return colAndRowSpanForImage[props.blockData.images.length][imageIndex + 1];
}

const headingContainerStyle = computed(() => {
  return `min-height: ${rowHeight.value}px;` + (props.blockData.bgColor ?? '');
});

function cutOffImageGrid(): boolean {
  return props.blockData.images.length > 8 && state.showAllImages === false;
}

function onLastImageLoaded(): void {
  if (state.isInitialLoad) {
    calculateStyles();
    state.isInitialLoad = false;
  }
}

function getFirstOneRowImageIndex(): number {
  return firstOneRowImage[props.blockData.images.length - 1];
}

// number of grid columns for amount images (default: 4 grid columns)
const colCountForAmountImages: Record<number, number> = {
  1: 2,
  2: 3,
  5: 3,
};

// key: amount of images, value: array with all col/row spans for images. index 0 = headline, index 1 = images[0]...
const colAndRowSpanForImage: Record<number, string[]> = {
  1: ['', ''],
  2: ['', '', ''],
  3: ['col-span-2', 'col-span-2 row-span-2', '', ''],
  4: ['col-span-2', 'col-span-2 row-span-2', 'col-span-2 row-span-2', '', ''],
  5: ['', 'col-span-2 row-span-2', '', '', '', ''],
  6: [
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
  ],
  7: ['col-span-2', 'col-span-2 row-span-2', '', '', '', '', '', ''],
  8: [
    'col-span-2',
    '',
    '',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
  ],
  9: [
    'col-span-2',
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
  ],
  10: [
    'col-span-2',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
  ],
  11: [
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
  ],
  12: [
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
  ],
  13: [
    'col-span-2',
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
    'col-span-2 row-span-2',
    '',
    '',
    '',
    '',
    '',
    '',
  ],
  14: [
    'col-span-2',
    '',
    '',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
    '',
    '',
    'col-span-2 row-span-2',
    'col-span-2 row-span-2',
    '',
    '',
  ],
};

// we need to know the first image index that occupies 1 row, to calculate image / rowhheight on load :/
const firstOneRowImage: Record<number, number> = {
  1: 1,
  2: 1,
  3: 2,
  4: 3,
  5: 2,
  6: 1,
  7: 2,
  8: 1,
  9: 4,
  10: 3,
  11: 1,
  12: 1,
  13: 2,
  14: 1,
};

type ImageGalleryExtendedDefaultState = {
  carouselIndex: number;
  showCarousel: boolean;
  showAllImages: boolean;
  isInitialLoad: boolean;
  gridRect?: DOMRectReadOnly;
};

const state: ImageGalleryExtendedDefaultState = reactive({
  carouselIndex: 0,
  showCarousel: false,
  showAllImages: false,
  isInitialLoad: true,
});

onUnmounted(() => {
  state.carouselIndex = 0;
  state.showCarousel = false;
  state.isInitialLoad = true;
});

const openImageCarousel = (imageIndex: number) => {
  state.carouselIndex = imageIndex;
  state.showCarousel = true;
};
</script>
